import { render, staticRenderFns } from "./QuantityCounter.vue?vue&type=template&id=70dcb1d4&"
import script from "./QuantityCounter.vue?vue&type=script&lang=js&"
export * from "./QuantityCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dcb1d4')) {
      api.createRecord('70dcb1d4', component.options)
    } else {
      api.reload('70dcb1d4', component.options)
    }
    module.hot.accept("./QuantityCounter.vue?vue&type=template&id=70dcb1d4&", function () {
      api.rerender('70dcb1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/QuantityCounter.vue"
export default component.exports